import _regeneratorRuntime from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import axios from 'axios';
var instance = axios.create({
  baseURL: "".concat(process.env.NEXT_PUBLIC_API_BASE_URL),
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': true ? window.navigator.language : 'fr'
  }
});
instance.interceptors.request.use(function (config) {
  var user = JSON.parse(localStorage.getItem('user'));

  if (user && user.accessToken) {
    config.headers['Authorization'] = "Bearer ".concat(user.accessToken);
  }

  return config;
}, function (error) {
  return Promise.reject(error);
});
instance.interceptors.response.use(function (res) {
  return res;
}, /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(err) {
    var originalConfig, user, rs, tokenResponse, _error$response;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            originalConfig = err.config;

            if (!(originalConfig.url !== '/auth/login' && err.response)) {
              _context.next = 22;
              break;
            }

            // Access Token was expired
            user = JSON.parse(localStorage.getItem('user'));

            if (!(err.response.status === 401 && user && !originalConfig._retry)) {
              _context.next = 22;
              break;
            }

            originalConfig._retry = true;

            if (!user) {
              _context.next = 21;
              break;
            }

            _context.prev = 6;
            _context.next = 9;
            return instance.post('/auth/refreshtoken', {
              refreshToken: user.refreshToken
            });

          case 9:
            rs = _context.sent;
            tokenResponse = rs.data;
            localStorage.setItem('user', JSON.stringify(tokenResponse));
            return _context.abrupt("return", instance(originalConfig));

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](6);

            if (404 === (_context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status)) {
              // If 404 on refreshtoken remove user from localstorage
              localStorage.removeItem('user');
            }

            return _context.abrupt("return", Promise.reject(_context.t0));

          case 19:
            _context.next = 22;
            break;

          case 21:
            return _context.abrupt("return", Promise.reject(err));

          case 22:
            return _context.abrupt("return", Promise.reject(err));

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 15]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
export default instance;